module.exports = __webpack_public_path__ + "img/empty.37e87db7.png";